import { useEffect, useState } from "react";
import axios from "axios";
import "./Gallery.css";

export default function Gallery() {
  const [gallery, setGallery] = useState([]);
  const [selected, setSelected] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    fetchGallery();
  }, []);

 const fetchGallery = () => {
  axios
    .get("http://dietdubacherla.in/diet_backend/get_gallery.php")
    .then((res) => {
      console.log("GALLERY RESPONSE:", res.data); // 🔥 ADD THIS
      setGallery(res.data);
    })
    .catch((err) => console.log(err));
};

  // AUTO CAROUSEL
  useEffect(() => {
    if (gallery.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === gallery.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [gallery]);

  return (
    <div className="container">

      {/* HERO CAROUSEL */}
  {gallery.length > 0 && (
  <div style={heroContainer}>
    
    {/* ONLY ONE IMAGE */}
    <img
      key={currentIndex}
      src={
        gallery[currentIndex].image?.startsWith("http")
          ? gallery[currentIndex].image
          : `http://dietdubacherla.in/diet_backend/uploads/${gallery[currentIndex].image?.replace("uploads/", "")}`
      }
      alt={gallery[currentIndex].title}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        position: "absolute",
        top: 0,
        left: 0,
        transition: "opacity 1.5s ease-in-out",
      }}
    />

    <div style={heroOverlay}>
      <h2>{gallery[currentIndex]?.title}</h2>
    </div>

  </div>
)}

      <h1 className="title">📸 College Gallery</h1>
      <p className="subtitle">Memories, Events & Campus Life</p>

      {/* PINTEREST GRID */}
      <div className="gallery-grid">
        {gallery.map((item) => (
          <div
            key={item.id}
            className="card"
            onClick={() => setSelected(item)}
          >
            <img
              src={
                item.image.startsWith("http")
                  ? item.image
                  : `http://dietdubacherla.in/diet_backend/uploads/${item.image}`
              }
              alt={item.title}
            />

            <div className="card-body">
              <h4>{item.title}</h4>
            </div>
          </div>
        ))}
      </div>

      {/* MODAL */}
      {selected && (
        <div className="overlay" onClick={() => setSelected(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <img
              src={
                selected.image.startsWith("http")
                  ? selected.image
                  : `http://dietdubacherla.in/diet_backend/uploads/${selected.image}`
              }
              alt={selected.title}
            />
            <p>{selected.title}</p>
            <button onClick={() => setSelected(null)}>✖ Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

/* ================= HERO STYLES ================= */

const heroContainer = {
  width: "100%",
  height: "350px",
  position: "relative",
  overflow: "hidden",
  borderRadius: "12px",
  marginBottom: "25px",
  background: "#000",
};

const heroImage = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  position: "absolute",
  top: 0,
  left: 0,
  transition: "opacity 1.5s ease-in-out",
};

const heroOverlay = {
  position: "absolute",
  bottom: "0",
  left: "0",
  width: "100%",
  padding: "15px",
  background: "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
  color: "white",
  zIndex: 3,
};